package com.wintermar.inspection.di

import com.apollographql.apollo.ApolloClient
import com.russhwolf.settings.Settings
import com.wintermar.inspection.AppDatabase
import com.wintermar.inspection.EnvConfig
import com.wintermar.inspection.Platform
import com.wintermar.inspection.core.data.AppSetting
import com.wintermar.inspection.core.data.AuthRefreshApi
import com.wintermar.inspection.core.data.AuthorizationEncryption
import com.wintermar.inspection.core.data.TokenInterceptor
import com.wintermar.inspection.core.ui.component.image.util.event_listener.UploadFileListener
import com.wintermar.inspection.core.ui.component.image.util.event_listener.UploadFileListenerImpl
import com.wintermar.inspection.feature.data.local.db.DriverFactory
import com.wintermar.inspection.feature.data.local.db.createDatabase
import com.wintermar.inspection.feature.data.repository.AuthRefreshClient
import com.wintermar.inspection.feature.domain.service.ChunkUploadService
import com.wintermar.inspection.feature.domain.service.PendingUploadService
import com.wintermar.inspection.feature.domain.service.SubmitRetryService
import com.wintermar.inspection.getPlatform
import com.wintermar.inspection.util.global_navigation.GlobalNavigationBus
import com.wintermar.inspection.util.global_navigation.GlobalNavigationBusImpl
import org.koin.core.module.Module
import org.koin.core.qualifier.named
import org.koin.dsl.module

expect val platformModule: Module

val sharedModule = module {
    single<Platform> { getPlatform() }

    single<AppSetting> {
        AppSetting(get<Settings>()) // requires single<Settings> provided by platformModule
    }

    single<AuthorizationEncryption> {
        AuthorizationEncryption(secretKey = EnvConfig.SECRET_KEY)
    }

    // create a refresh-only transport and Apollo client (no TokenInterceptor)
    single(named("refreshApollo")) {
        ApolloClient.Builder()
            .serverUrl(EnvConfig.API_URL)
            .build()
    }

    single<AuthRefreshApi> {
        AuthRefreshClient(get(named("refreshApollo")))
    }

    single<TokenInterceptor> {
        TokenInterceptor(
            authorizationEncryption = get<AuthorizationEncryption>(),
            appSetting = get<AppSetting>(),
            platform = get<Platform>(),
            authRefreshApi = get<AuthRefreshApi>(),
            navigationBus = get<GlobalNavigationBus>()
        )
    }

    single<AppDatabase> {
        createDatabase(get<DriverFactory>())
    }

    single<GlobalNavigationBus> { GlobalNavigationBusImpl() }
    single<UploadFileListener> { UploadFileListenerImpl() }
    single<ChunkUploadService> { ChunkUploadService() }
    single<PendingUploadService> { PendingUploadService() }
    single<SubmitRetryService> { SubmitRetryService() }
}
